"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _PageNavIcon = _interopRequireDefault(require("../icons/PageNavIcon"));
var _SpeedSelect = _interopRequireDefault(require("../SpeedSelect/SpeedSelect"));
var _Seperator = _interopRequireDefault(require("./Seperator"));
require("../SuperPager.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function Pagination(props) {
  var onPageChange = props.onPageChange,
    currentPage = props.currentPage,
    totalRecordsCount = props.totalRecordsCount,
    recordsPerPage = props.recordsPerPage,
    pageSizes = props.pageSizes,
    onPageSizesChange = props.onPageSizesChange;
  var _useState = (0, _react.useState)({
      id: recordsPerPage,
      size: recordsPerPage
    }),
    _useState2 = _slicedToArray(_useState, 2),
    pageSize = _useState2[0],
    setPageSize = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedPage = _useState4[0],
    setSelectedPage = _useState4[1];
  var DEFAULT_PAGE_SIZES = [10, 20, 30];
  (0, _react.useEffect)(function () {
    validation();
  }, []);
  var handlePageChange = function handlePageChange(e, type) {
    e.preventDefault();
    var page;
    if (type === "next") {
      page = currentPage + 1;
    } else if (type === "prev") {
      page = currentPage - 1;
    } else if (type === "input") {
      var pagesArray = getPagesArray();
      var pageNumber = parseInt(selectedPage);
      if (pagesArray.includes(pageNumber)) {
        page = pageNumber;
      } else {
        page = currentPage;
      }
    }
    onPageChange(page);
  };
  var getPageSizes = function getPageSizes() {
    var pageSizesArray = [];
    var arrayValues = pageSizes ? pageSizes : DEFAULT_PAGE_SIZES;
    arrayValues.forEach(function (page) {
      pageSizesArray.push({
        id: page,
        size: page
      });
    });
    return pageSizesArray;
  };
  var handleSizeChange = function handleSizeChange(option) {
    var pageSizes = option.size;
    var noOfPages = Math.ceil(totalRecordsCount / pageSizes);
    onPageSizesChange(pageSizes);
    if (currentPage < noOfPages) {
      onPageChange(currentPage);
    } else {
      onPageChange(noOfPages);
    }
    setPageSize({
      id: option.id,
      size: option.size
    });
  };
  var getPagesArray = function getPagesArray() {
    var noOfPages = Math.ceil(totalRecordsCount / recordsPerPage);
    var pagesArray = [];
    for (var i = 1; i <= noOfPages; i++) {
      pagesArray.push(i);
    }
    return pagesArray;
  };
  var validation = function validation() {
    var errorMessage;
    var isError = false;
    if (!onPageChange) {
      errorMessage = "onPageChange prop is mandatory";
      isError = true;
    } else if (!onPageSizesChange) {
      errorMessage = "onPageSizesChange prop is mandatory";
      isError = true;
    } else if (!currentPage) {
      errorMessage = "currentPage prop is mandatory";
      isError = true;
    } else if (totalRecordsCount === undefined) {
      errorMessage = "totalRecordsCount prop is mandatory";
      isError = true;
    } else if (!recordsPerPage) {
      errorMessage = "recordsPerPage prop is mandatory";
      isError = true;
    }
    if (isError) {
      throw new Error(errorMessage);
    }
  };
  var start = recordsPerPage * (currentPage - 1) + 1;
  var end = recordsPerPage * currentPage > totalRecordsCount ? totalRecordsCount : recordsPerPage * currentPage;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pagination-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pagination-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "records-info margin-spacing"
  }, /*#__PURE__*/_react["default"].createElement("p", null, start, " - ", end, " of ", totalRecordsCount, " Records")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "page-number"
  }, /*#__PURE__*/_react["default"].createElement("p", null, "Page ", currentPage, " / ", Math.ceil(totalRecordsCount / recordsPerPage))), /*#__PURE__*/_react["default"].createElement(_Seperator["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "page-nav-buttons margin-spacing"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "page-prev",
    disabled: currentPage <= 1 ? true : false,
    onClick: function onClick(e) {
      return handlePageChange(e, "prev");
    }
  }, /*#__PURE__*/_react["default"].createElement(_PageNavIcon["default"], null)), /*#__PURE__*/_react["default"].createElement("button", {
    className: "page-next",
    disabled: currentPage * recordsPerPage >= totalRecordsCount ? true : false,
    onClick: function onClick(e) {
      return handlePageChange(e, "next");
    }
  }, /*#__PURE__*/_react["default"].createElement(_PageNavIcon["default"], null))), /*#__PURE__*/_react["default"].createElement(_Seperator["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "page-size margin-spacing"
  }, /*#__PURE__*/_react["default"].createElement(_SpeedSelect["default"], {
    options: getPageSizes(),
    displayKey: "size",
    uniqueKey: "id",
    prominentLabel: "Rows",
    selectedOption: pageSize,
    onSelect: function onSelect(e) {
      return handleSizeChange(e);
    },
    disableSearch: true
  })), /*#__PURE__*/_react["default"].createElement(_Seperator["default"], null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "goto-page margin-spacing"
  }, /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: function onSubmit(e) {
      return handlePageChange(e, "input");
    }
  }, /*#__PURE__*/_react["default"].createElement("label", null, "Go to"), /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    className: "page-num-input",
    name: "page-num",
    value: selectedPage,
    onChange: function onChange(e) {
      return setSelectedPage(e.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "page-num-btn"
  }, "Go")))));
}
var _default = Pagination;
exports["default"] = _default;